// Single source of truth for brand configuration
//
// Usage:
// 1. In templates with utility classes:
//    <div class="brand-primary">Text in primary color</div>
//    <div class="brand-primary-bg">Background in primary color</div>
//    <div class="brand-primary-dark-border">Border in primary dark</div>
//
// 2. In SASS/SCSS:
//    color: $brand-primary;
//    background: $brand-primary-dark;
//
// 3. In JavaScript:
//    this.$brand.colors.primary.default
//
// 4. With Vuetify components:
//    <v-btn color="primaryDark">Button</v-btn>

const brandConfig = {
  colors: {
    primary: {
      light: "#4da0ca",
      default: "#1a4586",
      dark: "#051933",
    },
    // Add more brand colors here as needed
    // secondary: {
    //   light: '#...',
    //   default: '#...',
    //   dark: '#...'
    // },
    // accent: {
    //   light: '#...',
    //   default: '#...',
    //   dark: '#...'
    // }
  },
  // Add more theme properties here
  // typography: {
  //   fontFamily: {
  //     base: '...',
  //     heading: '...'
  //   },
  //   fontSize: {
  //     root: '16px'
  //   }
  // },
  // spacing: {
  //   unit: '8px'
  // },
  // borderRadius: {
  //   default: '4px',
  //   card: '4px'
  // }
};

export default brandConfig;
